if (!customElements.get('pr-lumbar-gallery')) {
  customElements.define('pr-lumbar-gallery', class extends HTMLElement {
    connectedCallback() {
      this.onclick = (event) => {
        const button = event.target.closest('[data-gallery-choice]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('[data-gallery-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
        this.querySelectorAll('[data-gallery-panel]').forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== button.dataset.galleryChoice; });
      };
    }
    disconnectedCallback() { this.onclick = null; }
  });
}
